import Form from 'components/Form';
import { IFormValues } from 'routes/Main/type';
import { Fragment } from 'react';
import { Stack } from '@mui/material';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContentSub';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues {
  disabled?: boolean;
}

const Memory = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="인지 - 기억력" />

      <RowContainer xs={12}>
        <RowContent title="과거기억" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('memory.past.value')}
              onChange={v => setValue('memory.past.value', v)}
            />
          </Stack>
        </RowContent>
        <RowContent title="최근기억" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('memory.recent.value')}
              onChange={v => setValue('memory.recent.value', v)}
            />
          </Stack>
        </RowContent>
        <RowContent
          title="즉각저장 및 회상"
          titleRatio={1.2}
          childrenRatio={10.8}
        >
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('memory.immediately.value')}
              onChange={v => setValue('memory.immediately.value', v)}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Memory;
